export default __webpack_public_path__ + "static/media/travel-tour-vehicle.127748e9.png";